import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions }  from '@material-ui/lab/Autocomplete';
import {Dialog,DialogTitle,DialogContent ,DialogContentText ,DialogActions,Button,Grid } from '@material-ui/core/';
import {isEmpty,isUndefined, isNull,isObject} from 'lodash'
import ColorPresets from '../../../aktiveter/ToDoDetail/AktivitetInfo/Inputs/ColorPresets'
import AddTagButton from '../../../aktiveter/ToDoDetail/AktivitetInfo/Inputs/AddTagButton'
import {CreateAktivitetTag} from 'actions'
import Tooltip from '@material-ui/core/Tooltip';
import Switch from '@material-ui/core/Switch';
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({accountsData,auth,Aktivitet}) {
    const { AktivitetTags } = accountsData;
    const { AllTagList } = Aktivitet;
    const { authUser } = auth;
    return {
      AktivitetTags,authUser,AllTagList
    };
}
const mapDispatchToProps= (dispatch)=>{
  return {
    CreateAktivitetTag: (Afid,Userid,label) => dispatch(CreateAktivitetTag(Afid,Userid,label)),    
    dispatch
  }
}
const filter = createFilterOptions();
class TagsInput extends Component {
    state={
        Value:"",
        open:false,
        Etikte:{
            keyword:"",
            color:"#000",
            isGlobal:0
        }
    }
    handleClose = () => {
        this.setState({
            Value:"",
            open:false,
            Etikte:{
                keyword:"",
                color:"#000",
                isGlobal:0
            }
        })
    }
    SaveThisEtikte=()=>{
     console.log(this.state.Etikte)
     let nEtikte ={
       keyword:isUndefined(this.state.Etikte.keyword.split(":")[1])?this.state.Etikte.keyword:this.state.Etikte.keyword.split(":")[1],
       color:this.state.Etikte.color,
       isGlobal:this.state.Etikte.isGlobal,
     }
     this.props.onchangeHanelTags(nEtikte);
      const userid = this.props.authUser.user_id;
      const Afid = this.props.authUser.user_Afid;
      this.props.CreateAktivitetTag(Afid,userid,nEtikte)
      this.handleClose()
    }
    onAddthis = (newValue)=>{
      if(!isEmpty(newValue)){
        this.setState({
          open:true,
          Etikte:{
            keyword:newValue.inputValue,
            color:"#000",
            isGlobal:0
          }
        })
      }
    }
    render() {
      console.log(this.state)
        return (
            <React.Fragment>
                <Autocomplete
                 value={this.state.Value}
                 onChange={(event, newValue) => {
                  if(!isNull(newValue) && isObject(newValue)){
                    if(isUndefined(newValue.isAdd)){
                    this.setState({
                      Etikte:{
                        keyword:newValue.keyword,
                        color:newValue.color,
                        isGlobal:newValue.isGlobal
                      }
                      })
                      this.props.onchangeHanelTags({
                        keyword:newValue.keyword,
                        color:newValue.color,
                        isGlobal:newValue.isGlobal
                    });
                    }
                  }else{
                    if(isNull(newValue)){
                      this.setState({
                        open:true,
                        Etikte:{
                          keyword:"",
                          color:"#000",
                          isGlobal:0
                        }
                      })
                    }
                  }
                  }}
                 filterOptions={(options, params) => {
                  const filtered = isEmpty(params.inputValue)?
                  this.props.AllTagList.slice(0,100)
                  :
                  this.props.AllTagList.filter(item => {
                    return item.keyword.toLowerCase().indexOf(params.inputValue.toLowerCase()) > -1
                  }).slice(0, 150)

                    //const filtered = filter(options, params);
                    if(isEmpty(filtered)){
                      filtered.push({
                        inputValue: params.inputValue,
                        keyword: <><IntlMessages id="Tag.Create1"/>: {params.inputValue}</>,
                        isAdd: true
                      });
                    }
                   return filtered;
                  }}
                 id="combo-box-demo"
                 options={this.props.AllTagList}
                 getOptionLabel={(option) => {
                    // e.g value selected with enter, right from the input
                    if (typeof option.inputValue === 'string') {
                      return option.inputValue;
                    }
                    if (option.inputValue) {
                      return option.inputValue;
                    }
                    return option.inputValue;
                  }}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  renderOption={(option) => {
                    if(isUndefined(option.isAdd)){
                      return  option.keyword
                    }
                    else{
                      return <AddTagButton option={option} isAdd={option.isAdd} onAddTagButton={this.onAddthis}/>
                    }
                  }}
                  freeSolo
                  renderInput={(params) => (
                      <TextField {...params} label={<IntlMessages id="Tag.Choose"/>} variant="outlined" size="small" />
                      )}
                />
 <Dialog open={this.state.open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
        
          <DialogTitle id="form-dialog-title"><IntlMessages id="Tag.Create"/></DialogTitle>
          <DialogContent>
          <Grid container>
          <Grid xs={8}>
          <TextField
              autoFocus
              variant="outlined" 
              margin="dense"
              size="small"
              id="Etiketter"
              InputLabelProps={{ shrink: true }} 
              value={this.state.Etikte.keyword}
              onChange={(event) => 
                this.setState({ 
                    ...this.state,
                    Etikte:{
                        ...this.state.Etikte,
                        keyword:event.target.value
                    }
                })}
              label={<IntlMessages id="Tags"/>}
              type="text"
            />
          </Grid>
          <Grid xs={2}>
          <TextField
              autoFocus
              variant="outlined" 
              margin="dense"
              size="small"
              id="Färg"
              style={{width:"50px"}}
              InputLabelProps={{ shrink: true }} 
              value={this.state.Etikte.color}
              onChange={(event) => 
                this.setState({ 
                    ...this.state,
                    Etikte:{
                        ...this.state.Etikte,
                        color:event.target.value,
                      }
                })}
              label={<IntlMessages id="Color"/>}
              type="color"
            />
          </Grid>
          <Grid xs={2} className="py-3">
          <Tooltip title={<IntlMessages id="Global.Tags.Tooltips"/>} placement="top">
          <Switch
          size={"small"}
          checked={parseInt(this.state.Etikte.isGlobal) === 0?false:true}
          onChange={(event) => 
            this.setState({ 
                ...this.state,
                Etikte:{
                    ...this.state.Etikte,
                    isGlobal:event.target.checked?1:0,
                  }
            })}
          color="primary"
          inputProps={{ 'aria-label': 'primary checkbox' }}
          />
          </Tooltip>
          </Grid>
          </Grid>
          <Grid container spacing={1} style={{marginTop: 5}}>
            <ColorPresets colorChange={(c) => {
                this.setState({ 
                    ...this.state,
                    Etikte:{
                        ...this.state.Etikte,
                        color: c
                    }
                })}}/>
          </Grid>
            
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
            <IntlMessages id="Cancel"/>
            </Button>
            <Button type="submit" color="primary" onClick={this.SaveThisEtikte}>
            <IntlMessages id="Add"/>
            </Button>
          </DialogActions>
        
      </Dialog>
      </React.Fragment>
        );
    }
}

export default connect(
    mapStateToProps,mapDispatchToProps
)(TagsInput);